import React from "react";
import { BeadCrumb, Typography } from "components";
// import TerminalCharts from "./TerminalCharts";
import AgentsRequests from "./AgentsRequests";
import { HiOutlineRefresh } from "react-icons/hi";

import "../style.scss";

const TerminalRequests = () => {
  return (
    <div
      className="dashboard-containter bg-light pt-3 px-4"
      style={{ paddingBottom: "4rem" }}
    >
      <BeadCrumb titles={["Terminals", "Terminal Requests"]} />
      <div className="d-flex terminal-requests-header justify-content-between">
        <Typography variant="subtitle1" component="h4" state="primary">
          Terminal Requests
        </Typography>
        <Typography
          state="grey"
          variant={"caption1"}
          className={"cursor-pointer d-none d-lg-block"}
          onClick={() => window.location.reload()}
        >
          Refresh this page <HiOutlineRefresh fontSize={"16px"} />
        </Typography>
      </div>
      {/* <TerminalCharts /> */}
      <AgentsRequests />
    </div>
  );
};

export default TerminalRequests;
